import React from 'react';
import { VerifyAccent } from './theme';

interface Props {
  boardName: string | null;
  accent: VerifyAccent;
}

/**
 * Item-context header that sits at the top of the verification card, inside the
 * existing Schmidt app shell (the global <Header/> is rendered by App.tsx).
 */
const VerifyHeader: React.FC<Props> = ({ boardName, accent }) => (
  <div className="rounded-t-lg overflow-hidden border border-b-0 border-gray-200">
    <div className={`h-2 ${accent.bar}`} />
    <div className="flex items-center justify-between px-5 py-3 bg-white">
      <span className="text-sm font-semibold text-gray-700">
        {boardName || 'Collectors Guild Registry'}
      </span>
      <span className={`text-xs font-semibold uppercase tracking-wide px-2 py-1 rounded ${accent.badge}`}>
        TTR Verified
      </span>
    </div>
  </div>
);

export default VerifyHeader;
